import { useQuestions } from "src/context/QuestionsProvider";
import AmhMessage from "./components/AmhMessage";

const Message = () => {
  const tag = useQuestions((q) => q.tag);

  if (tag === "AMH_MESSAGE") {
    return <AmhMessage />;
  }

  return null;
};

export default Message;
